import { render, staticRenderFns } from "./AboutUsDriver.vue?vue&type=template&id=77ba0730"
import script from "./AboutUsDriver.vue?vue&type=script&lang=js"
export * from "./AboutUsDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports